import React from "react";

const StatCard = ({ title, value, icon, green, red }) => (
  <div
    className={`flex items-center justify-between p-4 rounded-xl shadow
      transition-transform hover:-translate-y-1 ${
        green ? "bg-green-50" : red ? "bg-red-50" : "bg-indigo-50"
      }`}
  >
    <div>
      <p className="text-sm text-gray-600">{title}</p>
      <p className="text-2xl font-bold">{value}</p>
    </div>
    <div className="text-2xl text-gray-500">{icon}</div>
  </div>
);

export default StatCard;
